import { useNavigate } from 'react-router-dom';
import { Alert, Button } from '@tb/ui';
import { API_ERROR_CODE } from '@tb/shared';
import { RequestError } from '../api/client';
import { useT } from '../i18n/LocaleProvider';

const PAYWALL_CODES: string[] = [
  API_ERROR_CODE.planRequired,
  API_ERROR_CODE.siteQuotaExceeded,
  API_ERROR_CODE.customCodeRequired,
];

export function isPaywallError(error: unknown): error is RequestError {
  return error instanceof RequestError && PAYWALL_CODES.includes(error.code);
}

export function PaywallAlert({ error, siteId }: { error: RequestError; siteId?: string }) {
  const navigate = useNavigate();
  const t = useT();

  const isQuota = error.code === API_ERROR_CODE.siteQuotaExceeded;
  const isCode = error.code === API_ERROR_CODE.customCodeRequired;

  const title = isCode
    ? 'site.needsCustomCode.title'
    : isQuota
      ? 'site.quotaFull.title'
      : 'site.needsPlan.title';
  const body = isCode
    ? 'site.needsCustomCode.body'
    : isQuota
      ? 'site.quotaFull.body'
      : 'site.needsPlan.body';

  const to = isCode ? '/plans' : siteId ? `/plans/${siteId}` : '/plans';

  return (
    <Alert tone="warning" icon="lock" title={t(title)}>
      <div className="tb-stack" style={{ gap: 10 }}>
        <span>{t(body)}</span>
        <Button icon="sparkles" size="sm" onClick={() => void navigate(to)}>
          {t(isCode ? 'billing.unlockCode' : 'billing.choosePlan')}
        </Button>
      </div>
    </Alert>
  );
}
